import { LeadCurd } from "./leadCrud";

export default function CancellationLeads() {
  return <LeadCurd name="退单客户" type="cancellation" router="cancellation" />;
}
